export const monthNameShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
// Returns the ISO week of the date.
Date.prototype.getWeek = function () {
  let date = new Date(this.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  let week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
};

const getWeekNumber = (d) => {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNo;
};

const getWeeksInYear = (year) => {
  let d = new Date(year, 11, 31);
  let week = getWeekNumber(d);
  return week === 1 ? getWeekNumber(new Date(year, 11, 24)) : week;
};

const getDateRangeOfWeek = (weekNo, y) => {
  let d1, numOfdaysPastSinceLastMonday, rangeIsFrom, rangeIsTo;
  d1 = new Date("" + y + "");
  numOfdaysPastSinceLastMonday = d1.getDay() - 1;
  d1.setDate(d1.getDate() - numOfdaysPastSinceLastMonday);
  d1.setDate(d1.getDate() + 7 * (weekNo - d1.getWeek()));
  rangeIsFrom = d1.getDate() + "-" + monthNameShort[d1.getMonth()];
  d1.setDate(d1.getDate() + 6);
  rangeIsTo = d1.getDate() + "-" + monthNameShort[d1.getMonth()];

  return "Week " + weekNo + " (" + rangeIsFrom + " to " + rangeIsTo + ")";
};

const Daily = ({ yearTofetch, updateYearToFetch, weekToFetch, updateWeekToFetch }) => {
  return (
    <>
      <div className='dailyfilter32'>
        <div className='employeeTile22'>
          <div id='inputreset46' className='inputCustdet  '>
            <select onChange={(e) => updateYearToFetch(e.target.value)} value={yearTofetch}>
              <option value='' disabled selected hidden>
                {yearTofetch}
              </option>
              {new Array(10).fill(0).map((_, i) => (
                <option value={new Date().getFullYear() - i} key={i}>
                  {new Date().getFullYear() - i}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className='employeeTile22'>
          <div id='inputreset46' className='inputCustdet  '>
            <select onChange={(e) => updateWeekToFetch(e.target.value)} value={weekToFetch}>
              <option value='' disabled selected hidden>
                Select week number
              </option>
              {new Array(getWeeksInYear(yearTofetch)).fill(0).map((_, i) => (
                <option
                  disabled={getWeekNumber(new Date()) <= i && yearTofetch.toString() === new Date().getFullYear().toString() ? true : false}
                  value={getDateRangeOfWeek(i + 1, yearTofetch)}
                  key={i}
                >
                  {getDateRangeOfWeek(i + 1, yearTofetch)}{" "}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </>
  );
};

export default Daily;
